var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMoreVert24Line(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2993 17.1994C13.2993 16.4814 12.7173 15.8994 11.9993 15.8994C11.2813 15.8994 10.6993 16.4814 10.6993 17.1994C10.6993 17.9174 11.2813 18.4994 11.9993 18.4994C12.7173 18.4994 13.2993 17.9174 13.2993 17.1994Z",
    fill: "#868E96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2993 6.79902C13.2993 6.08102 12.7173 5.49902 11.9993 5.49902C11.2813 5.49902 10.6993 6.08102 10.6993 6.79902C10.6993 7.51702 11.2813 8.09902 11.9993 8.09902C12.7173 8.09902 13.2993 7.51702 13.2993 6.79902Z",
    fill: "#868E96"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2993 11.9992C13.2993 11.2812 12.7173 10.6992 11.9993 10.6992C11.2813 10.6992 10.6993 11.2812 10.6993 11.9992C10.6993 12.7171 11.2813 13.2992 11.9993 13.2992C12.7173 13.2992 13.2993 12.7171 13.2993 11.9992Z",
    fill: "#868E96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMoreVert24Line);
export default __webpack_public_path__ + "static/media/icon_more_vert_24_line.4436c070c36f5b2797038153564e1e22.svg";
export { ForwardRef as ReactComponent };